import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import SitesSearch from '../SitesSearch'
import Site from '../Site'

export default class SitesManager extends Component {
  render = () => {
    const { match } = this.props

    return (
      <ErrorBoundary>
        <Switch>
          <Route component={Site} path={`${match.path}/:id`} />
          <Route component={SitesSearch} path={match.path} />
        </Switch>
      </ErrorBoundary>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SitesManager/component.js